import { render } from "./UserCom.vue?vue&type=template&id=17fca280&scoped=true"
import script from "./UserCom.vue?vue&type=script&lang=js"
export * from "./UserCom.vue?vue&type=script&lang=js"

import "./UserCom.vue?vue&type=style&index=0&id=17fca280&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17fca280"]])

export default __exports__